/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Contact_LabelInputs */

const en_ticket_contact_label = /** @type {(inputs: Ticket_Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact:`)
};

const ja_ticket_contact_label = /** @type {(inputs: Ticket_Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連絡先:`)
};

const fr_ticket_contact_label = /** @type {(inputs: Ticket_Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact :`)
};

const de_ticket_contact_label = /** @type {(inputs: Ticket_Contact_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt:`)
};

/**
* | output |
* | --- |
* | "Contact:" |
*
* @param {Ticket_Contact_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_contact_label = /** @type {((inputs?: Ticket_Contact_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Contact_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_contact_label(inputs)
	if (locale === "ja") return ja_ticket_contact_label(inputs)
	if (locale === "fr") return fr_ticket_contact_label(inputs)
	return de_ticket_contact_label(inputs)
});